interface Faq {
  id: number
  category: '회원 정보' | '사전 준비' | '충전 및 출금' | '청약 및 배정' | '매각 및 정산' | '기타'
  title: string
  content: string
}

interface FaqList {
  list: Faq[]
}

const FaqData: FaqList = {
  list: [
    {
      id: 0,
      category: '회원 정보',
      title: '회원가입은 어떻게 하나요?',
      content:
        '아티피오 앱을 다운로드하시고 앱 실행 후, 로그인 버튼을 눌러주세요. 각 SNS 계정 로그인을 통해 간편하게 가입하실 수 있어요.',
    },
    {
      id: 1,
      category: '회원 정보',
      title: '미성년자의 경우 회원가입 및 서비스 이용이 가능한가요?',
      content:
        '만 14세 미만의 어린이 회원은 가입이 제한되며, 15세 이상은 회원 가입이 가능해요. 또한 만 19세 미만인 경우 투자 제한이 있으니 서비스 이용에 참고해 주세요.',
    },
    {
      id: 2,
      category: '회원 정보',
      title: '회원 탈퇴는 어떻게 하나요?',
      content: `회원 탈퇴는 [더보기] > [내 정보] > [회원 탈퇴]에서 하실 수 있어요.\n단, 보유하고 있는 작품이나 예치금이 있을 경우 탈퇴가 제한될 수 있어요.\n\n[작품을 보유하고 있는 경우]\n보유 작품(증권)이 존재하는 경우, 작품 매각 및 정산 완료 후 탈퇴가 가능해요.\n\n[예치금이 있는 경우]\nNH농협은행 가상 계좌에 잔액이 존재하는 경우, 모두 출금하셔야만 탈퇴가 가능해요.\n\n※회원탈퇴시, 등록한 농협 예치금 계좌 또한 자동으로 해지되는 점 참고 부탁드려요.`,
    },
    {
      id: 3,
      category: '회원 정보',
      title: '휴대폰 번호가 변경되었어요.',
      content: '휴대폰 번호는 [더보기] > [내 정보] > [휴대폰 번호]에서 변경하실 수 있어요.',
    },
    {
      id: 4,
      category: '회원 정보',
      title: '출금 계좌를 변경하고 싶어요.',
      content: '출금 계좌는 [더보기] > [내 정보] > [출금 계좌]에서 변경하실 수 있어요.',
    },
    {
      id: 5,
      category: '사전 준비',
      title: '통신사 본인 인증 절차는 어떻게 진행하나요?',
      content:
        '청약 신청 시, 본인 확인을 위해 통신사 본인 인증 절차를 진행하고 있어요. 본인 인증은 [더보기] > [내 정보] > [휴대폰 번호]에서 진행하실 수 있어요.',
    },
    {
      id: 6,
      category: '사전 준비',
      title: '자택 주소가 필요한가요?',
      content:
        '청약 신청 시, 필수 정보인 주소를 수집하고 있어요. [더보기] > [내 정보] > [자택 주소]에서 주소를 입력해 주세요.',
    },
    {
      id: 7,
      category: '사전 준비',
      title: 'NH농협 예치금 가상 계좌 생성은 어떻게 하나요?',
      content:
        '예치금을 충전시키거나 출금하실 수 있는 본인 명의의 실계좌를 먼저 등록해야 해요.\n출금 계좌는 [더보기] > [내 정보] > [출금 계좌]에서 등록하실 수 있어요.\n출금 계좌를 등록하고 난 후, 예치금 계좌 생성을 위한 약관에 동의해 주세요. 약관 동의 시, 예치금 가상 계좌 생성이 완료됩니다.\n\n※출금계좌 등록 시 주의 사항\n-본 계좌 번호가 아닌 평생 계좌 번호(휴대폰, 사업자 번호 등)는 등록이 불가능해요.\n-같은 계좌이지만, 계좌 번호가 변경된 경우, 변경된 계좌번호를 입력해 주세요.\n-금융사의 정책으로 오픈 뱅킹, 간편 결제를 통한 입금은 제한될 수도 있어요.',
    },
    {
      id: 8,
      category: '사전 준비',
      title: '투자 적합성 테스트는 무엇인가요?',
      content:
        '청약 및 투자계약증권 발행과 관련된 이해를 돕기 위해 실시하는 테스트를 의미해요. 총 12가지의 문항으로 구성되어 있으며, 모든 문항을 올바로 선택하셔야 테스트를 통과할 수 있고, 청약 신청이 가능해요. 테스트 기록은 2년간 보관되며, 2년마다 갱신하셔야 해요. 투자 적합성 테스트는 [더보기] > [투자 적합성 테스트]에서 진행하실 수 있어요.',
    },
    {
      id: 9,
      category: '충전 및 출금',
      title: '예치금은 어떻게 충전하나요?',
      content:
        '예치금 충전은 다음과 같은 절차로 진행하실 수 있어요. [투자 내역] > [충전하기] > [계좌번호 복사] 하신 후,\n등록하신 출금 계좌 은행 앱에서 복사한 계좌번호로 계좌이체를 진행해 주세요.\n충전한 예치금은 앱 내의 [투자내역] 예치금 탭에서 확인하실 수 있어요.\n\n※인터넷 상태 및 은행 규정에 따라 충전 완료 처리까지 지연이 될 수도 있어요.\n\n※본 계좌 번호가 아닌 평생 계좌 번호(휴대폰, 사업자 번호 등)는 등록이 불가능해요.\n※같은 계좌이지만, 계좌 번호가 변경된 경우, 변경된 계좌번호를 입력해 주세요.\n※금융사의 정책으로 오픈 뱅킹, 간편 결제를 통한 입금은 제한될 수도 있어요.',
    },
    {
      id: 10,
      category: '충전 및 출금',
      title: '예치금은 어떻게 출금하나요?',
      content:
        '예치금 출금은 다음과 같은 절차로 진행하실 수 있어요. [투자 내역] > [출금하기]에서 출금하실 금액 입력 후, 출금 신청 버튼을 눌러주세요.\n※인터넷 상태 및 은행 규정에 따라 충전 완료 처리까지 지연이 될 수도 있어요.',
    },
    {
      id: 11,
      category: '충전 및 출금',
      title: '타인 명의로 충전이 가능한가요?',
      content:
        '예치금을 충전하실 때에는 등록된 출금 계좌로만 입금이 가능하기 때문에 타인 명의의 계좌로는 충전이 불가능해요. ',
    },
    {
      id: 12,
      category: '충전 및 출금',
      title: '입출금 내역은 어디에서 확인하나요?',
      content: '입출금 내역은 [투자 내역] > [예치금] > [입출금 내역]에서 확인하실 수 있어요.',
    },
    {
      id: 13,
      category: '충전 및 출금',
      title: '출금 수수료가 있나요?',
      content:
        '매 출금 시마다 1,000원의 수수료가 부과돼요. 신청하신 출금 금액에서 수수료 1,000 원이 제외되고 등록하신 출금 계좌로 입금된다는 점 참고 부탁드려요.',
    },
    {
      id: 14,
      category: '청약 및 배정',
      title: '청약 일정은 어디에서 확인할 수 있나요?',
      content: '아티피오 모바일 앱 내에 [청약] 탭과 [공지사항]을 통해 확인하실 수 있어요.',
    },
    {
      id: 15,
      category: '청약 및 배정',
      title: '청약은 어떻게 신청하나요?',
      content:
        '아티피오 모바일 앱을 통해 신청이 가능해요. 자세한 절차는 앱 내의 [아티피오 투자 가이드]를 참고해 주세요.',
    },
    {
      id: 16,
      category: '청약 및 배정',
      title: '주당 가격이 어떻게 되나요?',
      content: '1주의 금액은 10,000원으로, [청약] 탭 내의 작품 상세 페이지에서 확인이 가능해요.',
    },
    {
      id: 17,
      category: '청약 및 배정',
      title: '청약 신청 시, 최소 또는 최대 한도 금액이 있나요?',
      content:
        '1인당 최소 청약 금액은 10,000원(1주)이며, 최대 청약 금액은 30,000,000원(3,000주)이에요.\n\n*최소 투자 금액은 개별 청약(작품)마다 달라질 수 있어요.\n*균등 또는 비례배정 방식 절차에 따라 투자자의 청약 신청수량 대비 적게 배정될 수 있어요.',
    },
    {
      id: 18,
      category: '청약 및 배정',
      title: '청약 신청수량 변경 또는 청약 취소는 어떻게 하나요?',
      content:
        '청약 취소는 청약 신청 기간 내에만 가능하며, [투자 내역] > [총 보유 자산] > 신청한 청약 작품 선택 > [자산 상세] > [청약 취소] 버튼을 선택하여 진행하실 수 있어요. 청약 신청 후 수량 변경 및 부분 취소는 불가능하며, 취소 후 다시 재청약을 하실 때, 수량을 변경하실 수 있어요.',
    },
    {
      id: 19,
      category: '청약 및 배정',
      title: '모집률이 100% 미만일 경우 어떻게 되나요?',
      content:
        '아티피오는 발행하는 증권의 10%를 선 배정 받아 취득하며, 청약 모집률이 100% 미만이 되는 경우, 잔여 지분을 모두 인수해요.',
    },
    {
      id: 20,
      category: '청약 및 배정',
      title: '배정 방식은 어떻게 이뤄지나요?',
      content:
        '청약이 마감되고 난 후 균등 또는 비례 방식으로 투자자에게 증권을 배정해요.\n전체 발행 수량의 10%는 아티피오에게 선 배정되고, 10%는 균등배정 방식으로, 나머지 80%는 경쟁률에 비례하여 배정되는 비례배정 방식으로 진행돼요. 배정 단계에서 각 청약 모집률, 경쟁률 등에 의하여 배정을 받지 못하실 수 있으니 투자 시 참고해 주세요. 청약에 따른 배정 결과는 아티피오 앱과 증권 발행 실적 보고서를 통해 확인하실 수 있어요.',
    },
    {
      id: 21,
      category: '청약 및 배정',
      title: '청약 신청 및 취소, 배정 등 각 진행 절차는 어디에서 확인할 수 있나요?',
      content:
        '청약 신청이 완료되고 나면, 앱 내의 [투자 내역] > [총 보유 자산] > 신청한 청약 작품 선택 > [자산 상세]에서 확인이 가능해요.',
    },
    {
      id: 22,
      category: '청약 및 배정',
      title: '배정을 받지 못하는 경우 어떻게 되나요?',
      content:
        '청약 경쟁률 상황에 따라, 신청한 수량의 일부 또는 전부를 배정받지 못할 수도 있어요. 배정받지 못한 투자금은 예치금 계좌로 자동 환불돼요. 환불금은 [투자 내역] > [예치금] > [입출금 내역]에서 확인하실 수 있어요.',
    },
    {
      id: 23,
      category: '매각 및 정산',
      title: '배정이 확정된 이후 매각은 어떻게 진행되나요?',
      content:
        '청약이 마감되고, 배정이 확정된 이후 아티피오는 국내외 갤러리, 경매 또는 개인 컬렉터 등 다양한 채널을 통해 해당 기초자산(작품) 매각을 진행해요. 매각에 소요되는 시간은 작품별로 상이할 수 있어요.',
    },
    {
      id: 24,
      category: '매각 및 정산',
      title: '매각 시 수익금은 어떻게 배분되나요?',
      content:
        '기초자산의 최종 매각 가격에서 매각과 관련된 비용, 제세공과금 및 당사의 성과 수수료(최종 매각 가격이 모집 총액의 108%를 초과하는 부분에 대한 20%, 부가세 별도)를 공제 후 보유 주에 비례하여 수익으로 배분돼요.\n\n[투자자 수익 및 성과보수 예시 : 모집가액 10,000원 기준]\n (1) 청산 시가 108%에 해당하는 경우\n    a. 공동사업 수익 : 1주당 800원\n    b. 성과보수 : 0원\n\n (2) 청산 시가 120%에 해당하는 경우\n    a. 공동사업 수익: 1주당 2,000원\n       = 청산 시가 120%에 해당하는 12,000원 - 모집가액 10,000원\n    b. 성과보수 : 1주당 264원\n       = (공동사업 수익 중 8%를 초과하는 수익 x 20%) x VAT 10%',
    },
    {
      id: 25,
      category: '매각 및 정산',
      title: '기초 자산의 감정은 어떻게 진행되나요?',
      content: '기초자산은 외부 여러 감정기관으로부터 진위감정 및 시가감정(자산의 가치 평가)을 받고 있어요.',
    },
    {
      id: 26,
      category: '매각 및 정산',
      title: '기초 자산이 매각되면 보유한 증권은 어떻게 되나요?',
      content: '현물 매각에 따른 이익/손실 분배 정산 완료와 동시에 증권은 소멸 또는 청산돼요.',
    },
    {
      id: 27,
      category: '매각 및 정산',
      title: '매각 후 수익금은 어디에서 확인할 수 있나요?',
      content:
        '작품의 매각을 통해 발생한 수익금은 예치금으로 상환되며,  [투자 내역] > [예치금] > [입출금 내역]에서 확인하실 수 있어요.',
    },
    {
      id: 28,
      category: '매각 및 정산',
      title: '매각 수익률과 상환 수익률이 차이가 나는 이유가 무엇인가요?',
      content:
        "매각 수익률은 기초 자산(작품)을 매각할 때, 배당소득세 및 성과보수 등의 비용은 배제한 채, '매각 금액 - 모집총액'으로 계산되는 수익률이고, 상환 수익률은 '매각 금액 - 모집총액'에서 배당소득세 및 투자 계약서에 명시된 성과보수 등의 비용을 차감한 수익금으로 계산되는 수익률이에요. ※자세한 내용은 투자설명서의 내용을 참고해 주세요.",
    },
    {
      id: 29,
      category: '매각 및 정산',
      title: '매각 후 수익금 정산 시, 주민등록번호는 왜 수집하나요?',
      content:
        '아티피오는 기초 자산(작품) 매각시, 배당소득에 대한 원천징수의 의무를 가지며, 이를 위해 주민등록번호를 수집해요. 수집된 주민등록번호는 암호화하여 별도 서버에 안전하게 보관하며, 원천징수 용도 외에는 사용되지 않아요.',
    },
    {
      id: 30,
      category: '기타',
      title: '해외에서도 아티피오를 이용할 수 있나요?',
      content: '아티피오는 현재 국내 전용 서비스로, 해외에서는 이용이 불가능해요.',
    },
    {
      id: 31,
      category: '기타',
      title: '투자 원금이 보장되나요?',
      content:
        "아티피오에서 발행하는 투자계약증권은 '예금자보호법'에 의한 보호를 받지 않는 상품으로 투자원금의 손실이 발생할 수 있어요. 이 점 유의하셔서 신중한 투자를 부탁드려요.",
    },
    {
      id: 32,
      category: '기타',
      title: '발행인이 투자자에게 제공하는 정보의 종류는 어떤 것들이 있나요?',
      content:
        '아티피오 앱의 공시를 통해 정기 공시, 수시 공지, 자율 공시, 조회 공시 및 주요사항에 대한 투자 정보를 제공하고 있어요.',
    },
    {
      id: 33,
      category: '기타',
      title: 'NH농협 예치금 가상 계좌 해지는 어떻게 하나요?',
      content: 'NH농협 예치금 가상 계좌 해지를 원하시는 고객님은 1:1문의하기를 통해 요청해 주세요.',
    },
    {
      id: 34,
      category: '기타',
      title: '투자설명서 및 투자계약서 등 청약 관련 문서는 어디에서 확인하나요?',
      content:
        '청약 관련 문서들은 [청약] > [작품 목록] 탭 내의 작품 상세페이지에서 확인이 가능하며, 청약 신청 이후에는 [투자 내역] > [총 보유 자산] > 신청한 청약 작품 선택 > [자산 상세]에서 확인이 가능해요.',
    },
    {
      id: 35,
      category: '기타',
      title: '기초자산(작품)의 실물은 어떻게 볼 수 있나요?',
      content:
        '청약기간 중 미술품을 관람할 수 있어요. 청약 기간 중의 관람은 홈페이지 및 증권신고서를 참고해 주시기 바라며, 청약이 종료된 후 관람은 해당 미술품을 취득한 투자자에게 한하여 단독으로 관람 시간을 예약할 수 있어요. 각 청약별로 일정과 기간은 변동될 수 있으니 자세한 사항은 증권신고서와 투자설명서에 기재된 일정을 확인해 주세요.',
    },
    {
      id: 36,
      category: '기타',
      title: '투자한 기초자산의 소유권은 어떻게 증명하나요?',
      content:
        '아티피오는 금융감독원으로부터 수리된 증권신고서와 사서인증을 통해 소유권을 증명해요. 투자자 명부가 확정되면 이를 공유 지분에 대한 입증 수단으로 사서인증을 하고 아티피오 앱을 통해 개별 투자자에게 제공해요. 배정 확정 이후, [투자 내역] > [총 보유 자산] > 신청한 청약 작품 선택 > [자산 상세] > [투자자 명부]에서 확인하실 수 있어요.',
    },
    {
      id: 37,
      category: '기타',
      title: '기초 자산(작품)은 어떻게 관리되고 있나요?',
      content:
        '아티피오에서 보유하고 있는 작품들은 도난방지, 항온항습, 화재예방 등의 시설이 완비되어 있는 미술품 전문 운송, 보관업체에서 보관, 관리되고 있어요.',
    },
    {
      id: 38,
      category: '기타',
      title: '기초 자산(작품)은 어떻게 취득하게 되나요?',
      content:
        '통상적으로 미술품은 화랑, 아트페어, 경매, 작가, 또는 개인 컬렉터 사이에서 거래되고 있어요. 이때 미술품이 거래되는 시장을 크게 1차 시장과 2차 시장으로 구분하는데 편의상 작가를 통해 처음 거래되는 시장을 1차 시장, 재판매가 이루어지는 곳을 2차 시장이라고 해요. 1차 시장의 유통기구에는 갤러리, 아트페어가 포함되며 이들은 소속 작가의 작품이 공공기관, 미술관 등에 소장되는 것을 우선 목표로 해요. 따라서 일반 개인이 작품의 우선권을 갖기 어려워요. 하지만 가격에서는 유통 마진 가장 적어 유리해요. 경매는 2차 시장을 대표하는 유통기구에요. 판매자와 구매자를 이어주는 중계 플랫폼으로 양측에서 수수료를 받아 운영해요. 경매회사는 매출을 극대화하기 위하여 전 세계 프리뷰 전시를 하고 작품 소개 영상 제작, 도록 제작 등 다양한 홍보 방법을 동원하고 있어요. 경매는 공개시장으로 작품의 낙찰가격, 수수료, 세금, 운송비 등 기타 세부 내역을 누구나 확인할 수 있어요.\n아티피오는 1, 2차 시장의 장단점을 충분히 인지하고 상황에 맞는 적절한 판단과 내외부 전문가 집단의 평가를 통해 기초 자산의 취득 여부를 결정해요.',
    },
    {
      id: 39,
      category: '기타',
      title: '아티피오가 도산 시, 어떻게 되나요?',
      content:
        "만일 아티피오가 도산 시 '사업 중단 시 청산 업무 등 처리 절차 규정'에 따라 업무 수행 체계가 유지되어 투자자 보호가 이루어질 수 있도록 독립된 제3자의 법무법인 및 예스24와의 사이에서 청산 대행 계약을 체결하고 있어요. 이를 통해 회사가 도산 시에 청산절차와 소유권 증빙에 따른 업무를 계약된 법무법인이 대행하며, 청산절차에 따라 투자자들의 기초자산(작품)을 미술시장에 매각하고 그 처분손익을 투자자분들에게 정해진 비율대로 배분해요.",
    },
    {
      id: 40,
      category: '기타',
      title: '공동 사업의 운영 기간은 어떻게 되나요?',
      content:
        '투자자 명부 확정일로부터 5년 이내가 원칙이지만, 상황에 따라서 추가로 5년 연장이 가능해요. 이 점 참고해 주세요.',
    },
    {
      id: 41,
      category: '기타',
      title: '기초 자산(작품) 매각 시 세금은 어떻게 되나요?',
      content:
        "2025년 7월 1일부터 *정부 정책 변경*에 따라 미술품 조각투자 수익금에 대한 세금 적용 방식이, 기타소득세에서 배당소득세로 변경되었어요.\n\n[※소득세법 제17조 제1항 제5의 4호 및 소득세법 시행령 제26조의3 제9항, 제10항]에 의하면 투자계약증권으로부터의 이익(매년 1회 이상 분배되는 이익을 말하며, 증권의 양도 거래로 발행한 이익 포함)은 배당소득으로 과세돼요.\n\n기존에 미술품 조각투자를 통해 얻으신 수익금에 대해서는 '기타소득세'가 적용되어 수익금의 22%(지방소득세 포함)를 세금으로 원천징수 후 지급해 드리도록 되어 있었어요. 하지만 2025년 7월 1일부터는 '배당소득세'가 적용되어 수익금의 15.4%(지방소득세 포함)를 세금으로 원천징수하도록 바뀌었어요.\n\n※원천징수세액(15.4%) = 배당소득세(14%) + 지방소득세(1.4%, 배당소득세의 10%)\n예시)수익금 100,000 원일 때, 세금 15,400 원 → 실수령 84,600 원\n\n\n※금융소득 종합과세: 배당소득은 다른 이자소득이나 배당소득과 합산하여 연간 2천만원을 초과하는 경우, 금융소득 종합과세 대상이 될 수 있어요.\n이 경우 다른 소득과 합산되어 더 높은 세율이 적용될 수 있으니, 다른 금융소득이 있으시다면 이 점을 꼭 확인해주세요.",
    },
    {
      id: 42,
      category: '기타',
      title: '개인간 양도/양수가 가능한가요?',
      content:
        '개인간 양도/양수에 대한 조건과 절차를 안내해 드려요.\n\n1.양도/양수 조건\n①증권 양도는 양도인이 양수인을 직접 선정했을 경우에만 가능해요.\n②반드시 양수인은 아티피오의 회원이어야 가능하며, 비회원인 경우, 신규 가입 및 본인인증, 예치금 계좌 개설 등의 절차가 필요해요.\n③양수인이 미성년자 또는 외국인인 경우, 양도가 불가능해요.\n④양도/양수 시의 증권 가격은 청약 시 가격과 동일해요.\n⑤양도/양수가 가능한 시점은, 증권 배정 이후부터 기초자산 매각전까지만 가능해요.\n\n2.양도/양수 절차\n①양도/양수를 희망하시는 분은 앱내의 [더보기]>[1:1 문의] 또는 artipio.official@gmail.com을 통해 문의해주세요.\n②메일 또는 앱을 통해서 양도승인 신청서 및 확약서 등 작성해야 할 양식을 공유해드려요. 해당 양식을 작성해주세요.\n③양도/양수가 완료되고 나서, 투자자 명부 변경내역을 익월 초에 공지해요.\n\n3.유의사항\n-양도인과 양수인간에 발생할 수 있는 분쟁은 아티피오와 무관해요.\n-양도/양수 비용이 발생할 수 있어요.\n-양도/양수 절차 간에 시스템 작업 및 투자자명부 변경에 따른 확정일자 공증 작업으로 시간이 소요될 수 있어요.',
    },
    {
      id: 43,
      category: '기타',
      title: '앱 사용시 오류가 나면 어떻게 하나요?',
      content:
        '아티피오 앱을 최신 버전으로 업데이트하신 후, 다시 한번 확인 부탁드려요. 그럼에도 지속적으로 오류가 발생되는 경우 1:1문의하기를 통해 구체적인 오류 증상에 대해 기입해 주세요. 최대한 빠른 시일 내에 문제를 해결해 드릴게요.',
    },
    {
      id: 44,
      category: '기타',
      title: '발급받은 NH농협 예치금 가상 계좌는 농협은행에서 실제로 사용가능한 계좌인가요?',
      content: '발급받으신 NH농협 예치금 가상 계좌는 아티피오 앱에서만 사용하실 수 있어요.',
    },
    {
      id: 45,
      category: '기타',
      title: 'NH농협 예치금 가상 계좌를 발급받으면 타 금융 통장이나 계좌 개설시 제한에 걸리나요?',
      content:
        '발급받으신 NH농협 예치금 가상 계좌는 추가 계좌 개설 시, 제한 규정에 걸리지 않아요. 안심하시고 발급받으세요.',
    },
  ],
}

export default FaqData
export type { Faq }
